module.exports = __webpack_public_path__ + "static/img/value3.b48820a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/value3.png
// module id = IDH4
// module chunks = 0